import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FunctionalHeaderCell from './FunctionalHeaderCell';
import SimpleHeaderCell from './SimpleHeaderCell';
import SortableHeaderCell from './SortableHeaderCell';
import ColumnClassNamesType from 'propTypes/columnClassNamesType';
import BulkCheckboxHeaderCell from './BulkCheckboxHeaderCell';

const HeaderCell = (props) => {
  const { header, sortName, type, columnClassNames } = props;

  let Component;

  if (typeof header === 'function') {
    // noinspection JSUnusedAssignment
    Component = FunctionalHeaderCell;
  } else if (type === 'bulkCheckbox') {
    Component = BulkCheckboxHeaderCell;
  } else if (sortName) {
    // noinspection JSUnusedAssignment
    Component = SortableHeaderCell;
  } else {
    // noinspection JSUnusedAssignment
    Component = SimpleHeaderCell;
  }

  const classes = [
    'contact-list-react-header',
    columnClassNames
  ];

  if (type) {
    classes.push(`contact-list-react-header-type-${type}`);
  }

  return (
    <th className={classNames(classes)}>
      <Component {...props} />
    </th>
  );
};

HeaderCell.propTypes = {
  /** The title of the column */
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** The string used to define this sort column */
  sortName: PropTypes.string,

  /** The type of column */
  type: PropTypes.string,

  /** Class name(s) to use on all cells in this column */
  columnClassNames: ColumnClassNamesType
};

HeaderCell.defaultProps = {
  header: '',
  sortName: '',
  type: undefined,
  columnClassNames: []
};

export default HeaderCell;
